import React, {useEffect, useRef} from "react";

import styles from "./ImageText.module.scss";
import Image from "../Global/Image";
import isMobile from "ismobilejs";

export default function ImageText ({image, rtl = false, classname = null, children}) {
    const article = useRef(null);

    useEffect(() => {
        const imageMobile = article.current.querySelector('[data-image-mobile]');

        if (imageMobile && isMobile().phone) {
            const image = article.current.getElementsByTagName('figure')[0];

           imageMobile.appendChild(image);
        }
    }, []);

    return (
        <article className={[styles.Main, rtl ? 'rtl' : '', classname ?? ''].join(' ')} ref={article}>
            <Image src={image.src} srcRet={image.srcRet} webp={image.webp} webpRet={image.webpRet} alt={children}/>

            <div>
                {children}
            </div>
        </article>
    )
}
